// extracted by mini-css-extract-plugin
export default {"scenarioTab":"ScenarioTab-module__scenarioTab__UFuFO","notActive":"ScenarioTab-module__notActive__tH8qP"};